export default __webpack_public_path__ + "static/media/specific-gravity.d4adb63c.png";